module.exports = __webpack_public_path__ + "img/SketchPng9c9b995fbf6bdc41ccc12fcfd4c6032a48a2b0b79824968ef62e0c923c05b0f6.706810f0.png";